/* unplugin-vue-components disabled */import script from "./collect.vue?vue&type=script&setup=true&lang=js"
export * from "./collect.vue?vue&type=script&setup=true&lang=js"

import "./collect.vue?vue&type=style&index=0&id=29570a67&scoped=true&lang=scss"

import exportComponent from "/Users/admin/Desktop/project/klb/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-29570a67"]])

export default __exports__